import { Component, ElementRef, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import { DynamicRenderizerComponentService } from '@common-modules/shared/services/dynamic-renderizer-component.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MapTopBarButtonsItemHostDirective } from './map-top-bar-buttons-item-host.directive';

const COMPONENT_SELECTOR = 'wlm-map-top-bar-buttons';

@UntilDestroy()
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './map-top-bar-buttons.component.html',
  styleUrls: ['./map-top-bar-buttons.component.scss'],
  standalone: false,
})
export class MapTopBarButtonsComponent implements OnInit {
  @Input() map: any;

  private _topBarConfiguration: MapTopbarButtonsConfiguration;
  public get topBarConfiguration(): MapTopbarButtonsConfiguration {
    return this._topBarConfiguration;
  }
  @Input() public set topBarConfiguration(value: MapTopbarButtonsConfiguration) {
    this._topBarConfiguration = value;
    if (value) {
      this.instanceComponent();
    }
  }

  private _buttonContainer: MapTopBarButtonsItemHostDirective;
  public get buttonContainer(): MapTopBarButtonsItemHostDirective {
    return this._buttonContainer;
  }
  @ViewChild(MapTopBarButtonsItemHostDirective) public set buttonContainer(
    value: MapTopBarButtonsItemHostDirective
  ) {
    this._buttonContainer = value;
    if (value) {
      this.instanceComponent();
    }
  }

  readonly T_SCOPE = `${AppModules.Map}.${COMPONENT_SELECTOR}`;

  constructor(
    private _element: ElementRef,
    private _dynamicRenderizerService: DynamicRenderizerComponentService
  ) {}

  ngOnInit(): void {}

  getNativeElement() {
    return this._element.nativeElement;
  }

  private instanceComponent() {
    if (!this.topBarConfiguration || !this.buttonContainer) {
      return;
    }

    this._dynamicRenderizerService.injectComponentIntoViewContainer(
      this.topBarConfiguration.buttonsComponent,
      this.buttonContainer.viewContainerRef,
      (component: any) => {
        component.params = this.topBarConfiguration.params;
      },
      this.topBarConfiguration.featureInjector
    );
  }
}

export class MapTopbarButtonsConfiguration {
  params: any;
  buttonsComponent;
  featureInjector: Injector;

  constructor(init: Partial<MapTopbarButtonsConfiguration>) {
    Object.assign(this, init);
  }
}
